<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('blogs')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Blog</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Title">
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
            required
          >
          </base-input>
        </b-form-group>
        <b-form-group
          label="Blog image (Max size 5MB and Dimensions should H-700, W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage != ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{
              aspectRatio: 2 / 1,
            }"
          />

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>
          <img v-if="image" :src="cropperImg" ref="cover" />
        </b-form-group>
        <b-form-group label="Description">
          <quill-editor
            v-model="body"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </b-form-group>

        <div class="mb-2">
          <b-form-group label="Tags:">
            <div class="md:flex justify-between items-center">
              <!-- Theme -->
              <b-form-select v-model="selectedtag" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <!-- type -->
              <b-form-select v-model="selectedSeg" class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <!-- user -->
              <multiselect
                class="mr-4"
                v-model="selectedUsers"
                :options="filter3"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="From Whom"
                track-by="name"
                label="name"
                :preselect-first="false"
              >
              </multiselect>
              <!-- {{ selectedUsers }} -->
              <!-- <b-form-select v-model="selectedUsers" class="mr-4">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              > -->

              <!-- Author -->
              <b-form-select v-model="selectedAuthor" class="mr-4">
                <b-form-select-option :value="null"
                  >{{
                    author.result.length !== 0 ? "Select Author" : "No Data"
                  }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="author in filter4"
                  :value="author._id"
                  :key="author._id"
                  >{{ author.name }}</b-form-select-option
                >
              </b-form-select>

              <!-- doctor -->
              <b-form-select v-model="selectedDoctor" class="">
                <b-form-select-option :value="null"
                  >{{
                    doctor.result.length !== 0
                      ? "Medically reviewed by"
                      : "No Data"
                  }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="doctor in filter5"
                  :value="doctor._id"
                  :key="doctor._id"
                  >{{ doctor.name }}</b-form-select-option
                >
              </b-form-select>
            </div>
          </b-form-group>
        </div>
        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-1" v-model="isFeatured">
            <p>
              <strong>
                <p class="col-blk">Click here to feature this blog.</p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <!-- ------------------------------------------------------------------------ -->
        <div class="mb-2 w-1/3">
          <div>
            <label for="date">Date:</label>
          </div>
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="Pick a date"
            :default-value="new Date()"
            format="dd-MM-yyyy"
            name="date"
          >
          </el-date-picker
          ><br />
          <span v-if="dateErr" class="text-center small text-danger">{{
            msg.date
          }}</span>
        </div>
        <!-- ------------------------------------------------------------------------ -->
        <!-- <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
          >
          </multiselect>
        </div> -->
        <!-- ----------------------------------------------------------------------------------- -->
        <div class="mb-2 pad">
          <!-- <b-form-group label="Label" v-slot="{ ariaDescribedby }">
            <div class="flex items-center gap-12">
              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some radio"
                value="A"
                >Option A</b-form-radio
              >
              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some radio"
                value="B"
                >Option B</b-form-radio
              >
            </div>
          </b-form-group> -->

          <b-form-radio-group
            v-model="isActive"
            :options="isActiveOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="onlyRegistered">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to limit access to the blog.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="isSelected">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on campaign.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <div class="mb-2">
          <b-form-checkbox id="checkbox-4" v-model="isSelectedCancer">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on Cancer page
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-5" v-model="isSelectedPalliative">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on palliative page
                </p></strong
              >
            </p></b-form-checkbox
          >
          <b-form-checkbox id="checkbox-6" v-model="isSelectedDementia">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on Dementia page
                </p></strong
              >
            </p></b-form-checkbox
          >
          <b-form-checkbox
            id="checkbox-7"
            v-model="isSelectedNeurodegenerative"
          >
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on Neurological Disorders
                  page
                </p></strong
              >
            </p></b-form-checkbox
          >
          <!-- <p class="mb-1 mt-3">Select a campaign to show this blog</p>
          <el-select
            v-model="selectedCampaigns"
            multiple
            placeholder="Select"
            key="dropOn"
            class="w-full mt-1"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <div class="mb-2 w-1/3">
            <label for="campaign">Campaigns:</label>
            <multiselect
              v-model="selectedCampaigns"
              :options="getCampaignOptions()"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              placeholder="Select Campaign"
              track-by="value"
              label="label"
            ></multiselect>
          </div>
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!onlyRegistered ? true : false"
          >
          </multiselect>
        </div>

        <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaKeyword"
            >
            </base-input>
          </div>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import _ from "lodash";
import { DatePicker } from "element-ui";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      isActiveOptions: [
        { item: true, name: "Active" },
        { item: false, name: "In-Active" },
      ],
      isActive: true,
      selected: "",
      title: "",
      image: null,
      coverImage: null,
      cropperImg: "",
      body: "",
      editorOption: {
        theme: "snow",
      },
      filter1: [],
      filter2: [],
      filter3: [],
      filter4: [],
      filter5: [],
      membershipFilter: [],
      selectedCampaigns: [],
      campaignOptions: [],
      selectedMembership: null,
      Ctags: [],
      selectedtag: null,
      selectedUsers: null,
      selectedSeg: null,
      selectedAuthor: null,
      selectedDoctor: null,
      selectedUsersId: [],
      onlyRegistered: false,
      isSelected: false, // campaign page checkbox to show blogs on this page
      isSelectedCancer: false,
      isSelectedPalliative: false,
      isSelectedDementia: false,
      isSelectedNeurodegenerative: false,
      isFeatured: false,
      date: null,
      imageErr: false,
      dateErr: false,
      msg: {
        name: "",
        image: "",
        date: "",
      },

      metaTitle: "",
      metaKeyword: "",
      metaDesc: "",
      metaCanonicalTag: "",
    };
  },
  computed: {
    ...mapState("cms", {
      filtertags: "filtertags",
      filters: "filters",
      selectedpagecategory: "selectedpagecategory",
    }),
    ...mapState("cmsAuthor", {
      author: "author",
    }),
    ...mapState("doctor", {
      doctor: "doctor",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  watch: {
    selectedUsers(val) {
      this.selectedUsersId = val.map((tag) => tag._id);
    },
  },
  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      // console.log(image);

      // 1048576
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      if (!this.onlyRegistered) {
        this.selectedMembership = null;
      }
      // console.log(this.date);
      if (this.date === null) {
        this.dateErr = true;
        this.msg.date = "Date is required";
        return;
      }
      // let FormData = require("form-data");
      let data = new FormData();
      this.Ctags.push(
        this.selectedtag,
        this.selectedSeg,
        ...this.selectedUsersId
      );
      data.append("type", "single");
      data.append("title", this.title);
      data.append("subTitle", "");
      data.append("media", this.coverImage);
      data.append("html", this.body);
      data.append("tags", JSON.stringify(_.uniq(this.Ctags)));
      data.append("pageCategory", this.selectedpagecategory.id);
      data.append("authors", JSON.stringify(this.selectedAuthor));
      data.append("doctors", JSON.stringify(this.selectedDoctor));
      data.append("memberships", JSON.stringify(this.selectedMembership));
      data.append("date", this.date);
      data.append("isFeatured", this.isFeatured);
      data.append("isSelectedCancer", this.isSelectedCancer);
      data.append("isSelectedPalliative", this.isSelectedPalliative);
      data.append("isSelectedDementia", this.isSelectedDementia);
      data.append(
        "isSelectedNeurodegenerative",
        this.isSelectedNeurodegenerative
      );
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );
      if (this.metaCanonicalTag)
        data.append("metaCanonicalTag", this.metaCanonicalTag);
      if (this.metaDesc) data.append("metaDesc", this.metaDesc);
      if (this.metaKeyword) data.append("metaKeyword", this.metaKeyword);
      if (this.metaTitle) data.append("metaTitle", this.metaTitle);

      if (this.selectedMembership !== null) {
        data.append("onlySubscribed", true);
        data.append("onlyRegistered", true);
      } else {
        data.append("onlySubscribed", false);
        data.append("onlyRegistered", this.onlyRegistered);
      }
      data.append("isActive", this.isActive);
      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      console.log(data, "data formData");

      try {
        const blogdata = await this.$store.dispatch("cms/addPage", data);
        if (blogdata.code == 200) {
          // this.$router.push({ name: "partnership" });
          this.$router.push({ name: "blogs" });
          this.$swal.fire({
            text: "Blog successfully added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    // payload only
    // async onSubmit() {
    //   if (!this.onlyRegistered) {
    //     this.selectedMembership = null;
    //   }

    //   // Checking if the date is provided
    //   if (this.date === null) {
    //     this.dateErr = true;
    //     this.msg.date = "Date is required";
    //     return;
    //   }

    //   // Combined tags
    //   this.Ctags.push(
    //     this.selectedtag,
    //     this.selectedSeg,
    //     ...this.selectedUsersId
    //   );

    //   // Created a payload object instead of FormData for scalability
    //   const payload = {
    //     type: "single",
    //     title: this.title,
    //     subTitle: "",
    //     media: this.coverImage,
    //     html: this.body,
    //     tags: JSON.stringify(_.uniq(this.Ctags)),
    //     pageCategory: this.selectedpagecategory.id,
    //     authors: JSON.stringify(this.selectedAuthor),
    //     doctors: JSON.stringify(this.selectedDoctor),
    //     memberships: JSON.stringify(this.selectedMembership),
    //     date: this.date,
    //     isFeatured: this.isFeatured,
    //     isSelected: this.isSelected,
    //     isSelectedCancer: this.isSelectedCancer,
    //     isSelectedPalliative: this.isSelectedPalliative,
    //     metaCanonicalTag: this.metaCanonicalTag || null,
    //     metaDesc: this.metaDesc || null,
    //     metaKeyword: this.metaKeyword || null,
    //     metaTitle: this.metaTitle || null,
    //     onlySubscribed: this.selectedMembership !== null,
    //     onlyRegistered:
    //       this.selectedMembership !== null ? true : this.onlyRegistered,
    //     isActive: this.isActive,
    //   };

    //   if (!this.coverImage) {
    //     this.$swal.fire({
    //       text: "Please Select Image",
    //       confirmButtonText: "Okay",
    //       confirmButtonColor: "#830c81",
    //       showCancelButton: false,
    //     });
    //     return;
    //   }

    //   let loader = this.$loading();

    //   try {
    //     const blogdata = await this.$store.dispatch("cms/addPage", payload);

    //     if (blogdata.code == 200) {
    //       this.$router.push({ name: "blogs" });
    //       this.$swal.fire({
    //         text: "Blog successfully added",
    //         icon: "success",
    //         confirmButtonText: "Okay",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       });
    //     }

    //     loader.close();
    //   } catch (error) {
    //     if (error) {
    //       loader.close();
    //     }
    //   }
    // },

    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredAPIData = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        {
          id: this.categoryId,
        }
      );

      this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);

      let filteredAuthorAPIData = await this.$store.dispatch(
        "cmsAuthor/getAuthor"
      );
      this.filter4 = this.author.result;

      let filteredDoctorAPIData = await this.$store.dispatch(
        "doctor/getDoctor"
      );
      this.filter5 = this.doctor.result;

      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
      // console.log(this.membershipFilter);
      // console.log(this.get_all_membership);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.gettagsbycategory();
  },
  //   async mounted() {
  //   this.$store.dispatch("campaignPageBanner/get_campaignhome");
  //   console.log("eeeee", this.campaignHome);
  // },
};
</script>
<style>
/* .pad .custom-control {
  padding-left: 1rem !important;
} */
</style>
